module.exports = "pegasus_template/assets/blocks/header-5-theme6.png";